import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import { Line } from "./Line/index.mjs";
import { clickablePoint, label } from "./index.css.mjs";
const BlueDotIcon = () => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsxs("g", { transform: "translate(-193.000000, -131.000000)", children: [
      "ß",
      /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { transform: "translate(0.000000, 68.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(176.000000, 62.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(0.000000, 1.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(17.000000, 0.000000)", children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            stroke: "#2765CF",
            strokeWidth: "3",
            fill: "#FFFFFF",
            cx: "12",
            cy: "12",
            r: "10.5"
          }
        ),
        /* @__PURE__ */ jsx("circle", { fill: "#2765CF", cx: "12", cy: "12", r: "6" })
      ] }) }) }) }) }) })
    ] }) })
  }
);
const BlueTickIcon = () => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsx("g", { transform: "translate(-193.000000, -130.000000)", children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { transform: "translate(0.000000, 68.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(176.000000, 62.000000)", children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { transform: "translate(17.000000, 0.000000)", children: /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx("circle", { fill: "#FFFFFF", cx: "12", cy: "12", r: "10" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12,0 C5.36374948,0 0,5.36374948 0,12 C0,18.6362505 5.36374948,24 12,24 C18.6362505,24 24,18.6362505 24,12 C24,5.36374948 18.6362505,0 12,0 Z M10.3128439,17.4201576 C10.0914199,17.6415816 9.81490391,17.7517489 9.53839347,17.7517489 C9.26188304,17.7517489 8.9853726,17.6415761 8.76394304,17.4201576 L4.45093322,13.1060418 L6.02682151,11.5301535 L9.51140606,15.0697636 L17.4201576,7.16101203 L18.9960459,8.73690032 L10.3128439,17.4201576 Z",
          fill: "#2765CF",
          fillRule: "nonzero"
        }
      )
    ] }) }) }) }) }) }) }) })
  }
);
const GrayCircleIcon = () => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsx(
      "g",
      {
        transform: "translate(-486.000000, -130.000000)",
        fill: "#FFFFFF",
        stroke: "#D6D6D6",
        strokeWidth: "4",
        children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { transform: "translate(0.000000, 68.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(176.000000, 62.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(303.000000, 0.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(7.000000, 0.000000)", children: /* @__PURE__ */ jsx("ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "10.5" }) }) }) }) }) })
      }
    ) })
  }
);
const GrayTickIcon = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx("desc", { children: "Created with Sketch." }),
      /* @__PURE__ */ jsx("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsx("g", { transform: "translate(-193.000000, -130.000000)", children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { transform: "translate(0.000000, 68.000000)", children: /* @__PURE__ */ jsx("g", { transform: "translate(176.000000, 62.000000)", children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { transform: "translate(17.000000, 0.000000)", children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { fill: "#FFFFFF", cx: "12", cy: "12", r: "10" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12,0 C5.36374948,0 0,5.36374948 0,12 C0,18.6362505 5.36374948,24 12,24 C18.6362505,24 24,18.6362505 24,12 C24,5.36374948 18.6362505,0 12,0 Z M10.3128439,17.4201576 C10.0914199,17.6415816 9.81490391,17.7517489 9.53839347,17.7517489 C9.26188304,17.7517489 8.9853726,17.6415761 8.76394304,17.4201576 L4.45093322,13.1060418 L6.02682151,11.5301535 L9.51140606,15.0697636 L17.4201576,7.16101203 L18.9960459,8.73690032 L10.3128439,17.4201576 Z",
            fill: "#747474",
            fillRule: "nonzero"
          }
        )
      ] }) }) }) }) }) }) }) })
    ]
  }
);
const getIcon = (stepIndex, activeStepIndex, maxStepIndexVisited) => {
  const active = stepIndex === activeStepIndex;
  if (active) {
    return /* @__PURE__ */ jsx(BlueDotIcon, {});
  }
  const completed = stepIndex < activeStepIndex;
  if (completed) {
    return /* @__PURE__ */ jsx(BlueTickIcon, {});
  }
  const previouslyVisited = stepIndex > activeStepIndex && stepIndex <= maxStepIndexVisited;
  if (previouslyVisited) {
    return /* @__PURE__ */ jsx(GrayTickIcon, {});
  }
  return /* @__PURE__ */ jsx(GrayCircleIcon, {});
};
const Icon = ({
  stepIndex,
  activeStepIndex,
  maxStepIndexVisited
}) => getIcon(stepIndex, activeStepIndex, maxStepIndexVisited);
const StepperProgressPoint = ({
  stepIndex,
  activeStepIndex,
  stepName,
  onClick,
  maxStepIndexVisited
}) => {
  const isFirstStep = stepIndex === 0;
  const isActiveStep = activeStepIndex === stepIndex;
  const handleOnClick = () => {
    if (onClick) {
      onClick(stepIndex);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !isFirstStep && /* @__PURE__ */ jsx(Box, { flexGrow: 1, children: /* @__PURE__ */ jsx(
      Line,
      {
        stepIndex,
        activeStepIndex,
        maxStepIndexVisited
      }
    ) }, `${stepIndex}Line`),
    /* @__PURE__ */ jsxs(
      Box,
      {
        position: "relative",
        className: { [clickablePoint]: onClick },
        onClick: handleOnClick,
        children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              stepIndex,
              activeStepIndex,
              maxStepIndexVisited
            }
          ),
          /* @__PURE__ */ jsx(Box, { paddingTop: "small", position: "absolute", className: label, children: /* @__PURE__ */ jsx(Text, { weight: isActiveStep ? "strong" : "regular", children: stepName }) })
        ]
      },
      `${stepIndex}Icon`
    )
  ] });
};
export {
  StepperProgressPoint
};
